import {RepositoryFactory} from "../../scripts/RepositoryFactory";


const DealRepository = RepositoryFactory.get('deals');

const state = {
    dates: [],
    range: {
        start: {},
        end: {}
    },
    search: '',
    missingDealIds: null,
    loading_deal: false,
    dealData: null,
    statusConfig: [ //name = DB Name,
        {
            name: 'pacing', alert: 'info', title: 'Pacing',
            description: 'Anzeige der aktuellen Auslieferung bei Deals, bei denen Budegt hinterlegt ist'
        },
        {
            name: 'active',
            alert: 'success',
            icon: 'check-circle',
            title: 'Aktiv',
            parent: {title: 'Aktiv', status: 'active'},
            description: 'Umsatz innerhalb der letzten 6 Monate',
            tooltip: 'Deal generiert Umsatz'
        },
        {
            name: 'inactive',
            alert: 'progressing',
            icon: 'clock',
            title: 'Inaktiv',
            parent: {title: 'Inaktiv', status: 'inactive'},
            description: 'Kein Umsatz seit mehr als 6 Monaten',
            tooltip: 'Kein Umsatz seit mehr als 6 Monaten'
        },
        {
            name: 'not_started',
            alert: 'progressing',
            icon: 'clock',
            title: 'Nicht gestartet',
            parent: {title: 'Inaktiv', status: 'inactive'},
            description: 'Es ist eine Deal ID eingetragen, Requests über 1000, aber noch nie ein Bid',
            tooltip: 'Keine Bids bisher'
        },
        {
            name: 'low_bid_rate',
            alert: 'warning',
            icon: 'exclamation-circle',
            title: 'Bid Rate',
            parent: {title: 'Optimierung empfohlen', status: 'warning'},
            description: 'Bid Rate liegt unter definierten Wert <0,01%',
            tooltip: 'Geringe Bid Rate'
        },
        {
            name: 'low_win_rate',
            alert: 'warning',
            icon: 'exclamation-circle',
            title: 'Win Rate',
            parent: {title: 'Optimierung empfohlen', status: 'warning'},
            description: 'Win Rate liegt unter definierten Wert <7%',
            tooltip: 'Geringe Win Rate'
        },
        {
            name: 'underdelivered',
            alert: 'warning',
            icon: 'exclamation-circle',
            title: 'Unterlieferung',
            parent: {title: 'Optimierung empfohlen', status: 'warning'},
            description: 'Impressions liegen 90% unter dem planmäßigen Pacing',
            tooltip: 'Unterlieferung'
        },
        {
            name: 'blocking',
            alert: 'error',
            icon: 'times-circle',
            title: 'Blocking',
            parent: {title: 'Aktion erforderlich', status: 'error'},
            description: 'Bids über 1000, aber AIs = 0 -> Bids des Buyers werden geblockt',
            tooltip: 'Bids des Buyers werden geblockt'
        },
        {
            name: 'low_requests',
            alert: 'error',
            icon: 'times-circle',
            title: 'Deal-Fehler',
            parent: {title: 'Aktion erforderlich', status: 'error'},
            description: 'Unter 1.000 Requests, aber NICHT gestoppt / deaktiviert / ausgelaufen -> Deal sendet zu wenig Requests',
            tooltip: 'Deal sendet zu wenig Requests'
        },
        {
            name: 'ended',
            alert: 'error',
            icon: 'times-circle',
            title: 'Ausgelaufen',
            parent: {title: 'Aktion erforderlich', status: 'error'},
            description: 'Das Enddatum des Deals wurde überschritten',
            tooltip: 'Enddatum wurde überschritten'
        },
        {
            name: 'deactivated',
            alert: 'error',
            icon: 'times-circle',
            title: 'Deaktiviert',
            parent: {title: 'Aktion erforderlich', status: 'error'},
            description: 'Deal wurde von Yieldlab automatisch deaktiviert',
            tooltip: 'von YL automatisch deaktiviert'
        },
    ]
};

const actions = {
    async fetchAllAvailableDates({commit}) {
        const {data} = await DealRepository.getAvailableDates();
        let dates = [];
        for (let i = 0; i < data.result.length; i++) {
            dates.push(data.result[i].date);
        }
        commit('setDates', dates);
    },
    async fetchDeal({commit}, payload) {
        state.loading_deal = true;
        try {
            const {data} = await DealRepository.getDeal(payload.id, payload.dates);
            commit('setDealData', data.result ? data.result : data);
            state.loading_deal = false;
        } catch (e) {
            state.loading_deal = false;
        }
    },
    async fetchMissingDealIds({commit}) {
        const {data} = await DealRepository.getMissingDealIds();
        commit('setMissingDealIds', data);
    }
};


// mutations
const mutations = {
    setDates(state, dates) {
        state.dates = dates;
    },
    setRange(state, range) {
        state.range = range;
    },
    setSearch(state, data) {
        state.search = data;
    },
    setMissingDealIds(state, data) {
        state.missingDealIds = data;
    },
    setDealData(state, data) {
        state.dealData = data;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}